import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    // theme: { dark: true },
    theme: {
        dark: true,
        themes: {
          light: {
            // header: colors.indigo,
            header: '#212121',
            background: null,
            primary: colors.blue.lighten1,
            // secondary: colors.grey.darken3,
          
          },
          dark: {
            header: '#212121',
            background: null,
            primary: colors.blue.lighten1,
            // secondary: colors.grey.darken3,
          },
        },
    },
});
